import styled from "styled-components"

export const Header = styled.div`
    /* Start a new Stacking Context for the Header */
    position: relative;
    z-index: 1;
`
